(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["smyth-header"]) return;
  try {
    
  // Mobile drawer: clones the desktop menu so the items and their anchor
  // behaviour (MEN'S / WOMEN'S scroll + focus) stay in sync automatically.
  document.querySelectorAll('.smyth-header').forEach(function (header) {
    // Overlay bar: solid-white treatment once the page leaves the very top.
    // The class is set on every viewport; only the desktop CSS acts on it.
    if (header.classList.contains('smyth-header--overlay')) {
      var syncStuck = function () {
        header.classList.toggle('is-stuck', window.scrollY > 8);
      };
      syncStuck();
      window.addEventListener('scroll', syncStuck, { passive: true });
    }

    // The wordmark is a plain button with no navigation, so wire it to return
    // to the top of the page. It is hidden on phones, so this is desktop and
    // tablet only in practice.
    var logo = header.querySelector('.smyth-header__logo');
    if (logo) {
      logo.addEventListener('click', function () {
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    var burger = header.querySelector('.smyth-header__burger');
    var drawer = header.querySelector('.smyth-header__drawer');
    var menu = header.querySelector('.smyth-header__menu');
    if (!burger || !drawer || !menu) return;

    drawer.querySelector('.smyth-header__drawer-nav').innerHTML = menu.innerHTML;
    burger.setAttribute('aria-expanded', 'false');

    var open = function () {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      document.documentElement.classList.add('smyth-drawer-lock');
      burger.setAttribute('aria-expanded', 'true');
    };
    var close = function () {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('smyth-drawer-lock');
      burger.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        drawer.hidden = true;
      }, 300);
    };

    burger.addEventListener('click', open);
    drawer.addEventListener('click', function (event) {
      // Backdrop, the close button, or any menu link closes the drawer; the
      // link's own navigation (smooth scroll to the section) still runs.
      if (event.target.closest('[data-drawer-close]') || event.target.closest('a')) {
        close();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) close();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smyth-product-feature"] && !Shopify.designMode) return;
  try {
    
  // Colour and size pickers: selection is cosmetic — the highlight moves and
  // the label above updates, but nothing is added to a cart.
  document.querySelectorAll('.smyth-pdp__swatches, .smyth-pdp__sizes').forEach(function (group) {
    // The label sits directly above each group.
    var label = group.previousElementSibling;
    if (label && !label.hasAttribute('data-option-label')) {
      label = label.querySelector ? label.querySelector('[data-option-label]') : null;
    }

    group.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.is-active').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        // "Color: BLUSH" -> "Color: SKY". Left alone if the merchant wrote a
        // label without a colon, since there is nothing safe to swap.
        if (!label) return;
        var value = btn.getAttribute('aria-label') || btn.textContent.trim();
        var head = label.textContent.split(':')[0];
        if (value && label.textContent.indexOf(':') !== -1) {
          label.textContent = head + ': ' + value;
        }
      });
    });
  });

  // Gallery: clicking a thumbnail shows its high-res image in the main slot.
  document.querySelectorAll('.smyth-pdp__gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.smyth-pdp__main');
    var mainImg = main && main.querySelector('img');
    if (!mainImg) return;

    gallery.querySelectorAll('.smyth-pdp__thumb-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gallery.querySelectorAll('.smyth-pdp__thumb-btn.is-active').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        var thumbImg = btn.querySelector('img');
        var next = btn.dataset.large || (thumbImg && (thumbImg.currentSrc || thumbImg.src));
        if (!next || mainImg.getAttribute('src') === next) return;

        // srcset/sizes would otherwise keep winning over the new src.
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        main.classList.add('is-swapping');
        mainImg.addEventListener('load', function once() {
          main.classList.remove('is-swapping');
          mainImg.removeEventListener('load', once);
        });
        mainImg.src = next;
        if (thumbImg && thumbImg.alt) mainImg.alt = thumbImg.alt;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
